import React, { useEffect, useState } from 'react';
import { TextInput } from 'carbon-components-react';
import './parameter.scss';
import { segmentTracking } from '../lib/tracker';

interface ParameterCompProps {
  captionClassName: string;
  captionText: string;
  textId: string;
  labText: string;
  defValue: string;
  setValue: React.Dispatch<React.SetStateAction<number>>;
  prefix: string;
  posfix: string;
  applyFormat: boolean | null;
  setApplyFormat: React.Dispatch<React.SetStateAction<boolean>> | null;
  fieldName: string;
}

const Parameter: React.FC<ParameterCompProps> = ({
  captionClassName,
  captionText,
  textId,
  labText,
  defValue,
  setValue,
  prefix,
  posfix,
  applyFormat,
  setApplyFormat,
  fieldName,
}) => {
  const [contain, setContain] = useState(defValue);
  useEffect(() => {
    if (applyFormat && prefix.length > 0 && !contain.includes(prefix)) {
      setContain(prefix + contain + posfix);
      setApplyFormat ? setApplyFormat(false) : null;
    }
  }, [contain, applyFormat]);
  return (
    <>
      <div className="bx--row parameter_header">
        <div className="bx--col-lg-16 bx--col-md-12 bx--col-sm-4">
          <p className={captionClassName}>{captionText}</p>
        </div>
      </div>
      <div className="bx--row parameter_input">
        <div className="bx--col-lg-4 bx--col-md-3 bx--col-sm-4">
          <TextInput
            type="text"
            id={textId}
            labelText={labText}
            value={contain}
            onChange={(e) => {
              const element = e.currentTarget as HTMLInputElement;
              const tvalue = element.value.replaceAll(/[^\d.-]/g, '');
              setContain(tvalue);
              setValue(parseInt(tvalue));
              segmentTracking('CTA Clicked', {
                pageTitle: 'PA ROI Pricing Page',
                object: 'Pricing Page',
                resultValue: tvalue,
                CTA: `Entered ${fieldName} field`,
                location: 'ROI Estimator',
                action: 'CTA clicked',
                field: '',
              });
            }}
          ></TextInput>
        </div>
      </div>
    </>
  );
};
export default Parameter;
